export default __webpack_public_path__ + "static/B0265-f37198bc05013dd8855abba4e64a751a.png";